<template>
  <base-snake 
    :steps="months"
    :color="color"
    :start="start"
    :end="end"
    :labels="labels"
  /> 
</template>

<script>
import BaseSnake from './BaseSnake'
import { required } from 'vee-validate/dist/rules'
import { lab } from 'd3'


const MONTH_NAMES = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

export default {
  name: 'time-snake',
  components: {
    BaseSnake,
  },
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
    snakeStartDate: {
      type: Date,
      required: true,
    },
    snakeEndDate: {
      type: Date,
      required: true,
    },
    color: {
      type: String,
      default: 'info',
    },
    // labels: {
    //   type: [Array, Object],
    //   default: () => [],
    // }
  },
  methods: {
    distanceInMonths(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
  },
  computed: {
    labels() {
      var labels = []
      let startMonth = this.snakeStartDate.getMonth()
      let startYear  = this.snakeStartDate.getFullYear()

      for (let index = 0; index < this.months; index++) {
        var label = MONTH_NAMES[(startMonth + index) % MONTH_NAMES.length]
        label += ' de '
        label += parseInt((startMonth + index)/12) + startYear
        labels.push(label);
      }

      return labels
    },
    months() {
      return this.distanceInMonths(this.snakeStartDate, this.snakeEndDate)
    },
    start() {
      return this.distanceInMonths(this.snakeStartDate, this.startDate)
    },
    end() {
      return this.distanceInMonths(this.snakeStartDate, this.endDate)
    },
  }
}
</script>
